var render, staticRenderFns
import script from "./msBaseComponent.vue?vue&type=script&lang=js"
export * from "./msBaseComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e6f40b",
  null
  
)

export default component.exports